<template>
	<div v-html="component.content && component.content.content"></div>
</template>

<script>
export default defineNuxtComponent({
	name: "CleanRender",
	props: ["component"],
});
</script>
